/* angular:styles/component:css;b9c51fb86354fd3f866a3ffa9f5128ac417a6ee7c935a71ecc590dea4a64f1d5;/src/src/app/edge/live/Controller/Evse/pages/forecast/forecast.ts */
.ion-justify-with-space-between ion-row > ion-col:nth-child(2) {
  text-align: right;
}
form {
  align-content: center !important;
}
/*# sourceMappingURL=forecast.css.map */
